import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { checkStoreState, setInitialStoreState } from '../../../../../common/utils';
import { UserItemFacade } from './user-item.facade';

@Injectable({
  providedIn: 'root',
})
export class UserItemGuard {
  constructor(private userItemFacade: UserItemFacade) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const {
      params: { userId },
    } = route;
    return checkStoreState(this.userItemFacade, userId);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.userItemFacade);
  }
}
